import { useState } from "react";
import { usePodcastProvider } from "./PodcastProvider";
import { controls } from "react-media-player";
import Marquee from "react-fast-marquee";
import { secondsToHms } from "services/utils";
import { getPodcastThemeToken } from "services/utils/getPodcastThemeToken";
//ui
import { Button, Box, Flex, Text } from "@chakra-ui/react";
import { VolumeIcon } from "components/icons";
import { CustomMediaSlider, CustomVolumeSlider, CustomPlayPause } from "./CustomMediaPlayer";
import PodcastColorTypes from "types/podcastColorTypes";

export function PodcastPlaybar() {
  const [displayProgressBar, setDisplayProgressBar] = useState<boolean>(true);
  const { volume, setVolume, playPodcast, setPlayPodcast, playingPodcast, setPlayingPodcast, expandedScreenModal } = usePodcastProvider();
  const { CurrentTime } = controls;

  const duration = playingPodcast ? secondsToHms(playingPodcast?.length) : 0;

  return (
    <Box
      width="100%"
      display={playPodcast ? "flex" : "none"}
      bg={getPodcastThemeToken(PodcastColorTypes.PlaybarBackground)}
      color={getPodcastThemeToken(PodcastColorTypes.PlaybarText)}
      onMouseEnter={() => {
        setDisplayProgressBar(true);
      }}
      onMouseLeave={() => {
        setDisplayProgressBar(false);
      }}
      transition="all 0.3s"
      position={{ base: "relative", md: "sticky" }}
      top="0"
      zIndex="50"
      height={{ base: "auto", md: "72px" }}
    >
      <Flex
        pl={{ base: `${displayProgressBar ? "39px" : "16px"}`, md: "32px" }}
        pr={{ base: `${displayProgressBar ? "39px" : "16px"}`, md: `${volume ? "21px" : "32px"}` }}
        flexDir={{ base: "column", md: "row" }}
        alignItems="center"
        color="white"
        justifyItems="space-between"
        maxWidth={{ base: "100%", md: "1512px" }}
        width="100%"
        margin="auto"
        py={{ base: "12px", md: "0" }}
      >
        <Flex maxW={{ base: "100%", md: "28%" }} width="100%" mr={{ md: "44px" }} alignItems="center" justifyContent="space-between" ml={{ md: "64px" }}>
          <Box width="48px" mr="12px" height="48px" display={{ base: "flex", md: "none" }}>
            <CustomPlayPause />
          </Box>
          <Marquee gradient={false}>
            <Text width="100%" fontWeight="600" fontSize="14px" lineHeight="24px" fontFamily="sora" color="inherit">
              {playingPodcast?.title}
            </Text>
          </Marquee>
          <Flex
            display={{ base: `${displayProgressBar ? "none" : "flex"}`, md: "none" }}
            onClick={() => {
              setPlayPodcast(false);
            }}
          >
            <CustomPlayPause cancel={true} />
          </Flex>
        </Flex>
        <Flex maxW={{ base: "100%", md: "65%" }} width="100%" alignItems="center" justifyContent="space-between">
          <Box width="48px" mr="20px" height="48px" borderRadius="50%" display={{ base: "none", md: "flex" }}>
            <CustomPlayPause />
          </Box>
          <Flex
            flexDirection="column"
            pt={{ base: "20px", md: "27px" }}
            display={{ base: `${displayProgressBar ? "flex" : "none"}`, md: "flex" }}
            transition="all 0.3s"
            pb={{ md: "11px" }}
            mr="10px"
            maxWidth="648px"
            width="100%"
            fontSize="12px"
            lineHeight="16px"
            fontFamily="sora"
          >
            {!expandedScreenModal && <CustomMediaSlider />}
            <Flex justifyContent="space-between" mt="16px" width="100%">
              <div>
                <CurrentTime />
              </div>

              <div>{duration}</div>
            </Flex>
          </Flex>
          <Button
            bgColor="transparent"
            width="48px"
            height="48px"
            color="white"
            _hover={{ bg: "transparent", color: "purple.50" }}
            _focus={{ outline: "none", bg: "transparent" }}
            onClick={e => setVolume(!volume)}
            display={{ base: "none", md: "flex" }}
            mr="10px"
          >
            <VolumeIcon width="48px" height="48px" />
          </Button>
          {volume ? (
            <Flex maxWidth="105px" width="100%" display={{ base: "none", md: "flex" }}>
              <CustomVolumeSlider />
            </Flex>
          ) : (
            <Flex
              display={{ base: "none", md: "flex" }}
              onClick={() => {
                setPlayPodcast(false);
                setPlayingPodcast(null);
              }}
            >
              <CustomPlayPause cancel={true} />
            </Flex>
          )}
        </Flex>
      </Flex>
    </Box>
  );
}
